import { Dialog } from 'material-ui';
import * as React from 'react';
import { deleteModule } from '../../services/moduleService';
import { CustomFlatButton } from '../reusableComponents/CutomFlatButton';
import { IHistory } from '../../interfaces';

export interface IDeleteModuleDialogProps {
    moduleIds: string[];
    onClose: Function;
    open: boolean;
    textToDisplay: string;
    history: IHistory;
}

export interface IDeleteModuleDialogState {
    open: boolean;
}

export class DeleteModuleDialog extends React.PureComponent<IDeleteModuleDialogProps, IDeleteModuleDialogState> {
    constructor(props: IDeleteModuleDialogProps) {
        super(props);
        this.state = { open: false };
    }

    public componentWillReceiveProps(nextProps: IDeleteModuleDialogProps) {
        this.setState({
            open: nextProps.open
        });
    }

    public handleClose = () => {
        this.setState({
            open: false
        });
        this.props.onClose();
    }

    public handleUserDelete = async () => {
        const { moduleIds, textToDisplay } = this.props;
        try {
            await deleteModule(moduleIds, textToDisplay, this.props.history);
            this.setState({ open: false });
        } catch (error) {
            this.setState({ open: false });
            throw error;
        }
    }

    public render() {
        return <Dialog
            title={`Do you really want to delete ${this.props.textToDisplay}?`}
            modal={false}
            className="url-modal"
            open={this.state.open}
            actions={
                [
                    <CustomFlatButton
                        label="No"
                        color={'black'}
                        primary={true}
                        onClick={this.handleClose}
                    />,
                    <CustomFlatButton
                        label="Yes"
                        color={'black'}
                        primary={true}
                        onClick={this.handleUserDelete}
                    />
                ]
            }
            onRequestClose={this.handleClose}
        >
            Click yes to proceed or No to cancel
    </Dialog>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/DeleteModuleDialog.tsx